import axios from 'axios';
import { Api } from 'lib';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { EntitySettings } from 'screens/Admin/components';

const API_URL = process.env.REACT_APP_API_URL;

const Settings = ({ team, setShowRemoveAlert }) => {
  const [loading, setLoading] = useState(null),
    dispatch = useDispatch();

  async function sendVerificationEmail() {
    try {
      await axios.post(`${API_URL}/admin/sendVerificationEmail`, { userId: team._id });

      dispatch({
        type: 'HANDLE_RES',
        payload: { res: 'Verification email sent.' }
      });
    } catch (e) {
      const message = e.response?.data
        ? e.response.data
        : 'Something went wrong.\nPlease try again later.';

      dispatch({
        type: 'HANDLE_RES',
        payload: { err: message }
      });
    }
  }

  async function toggleBan() {
    setLoading('ban');

    const res = await Api.post('/admin/toggleBan', { userId: team._id });
    setLoading(null);
    if (!res) return null;

    dispatch({
      type: 'HANDLE_RES',
      payload: { res: res.banned ? 'Team banned.' : 'Team unbanned.' }
    });

    dispatch({
      type: 'ADMIN_EDIT_TEAM',
      payload: {
        ...team,
        ...res
      }
    });
  }

  if (!team) return null;

  const settings = [
    {
      text: 'Resend verification email',
      icon: 'emailNotification',
      onClick: sendVerificationEmail
    },
    {
      text: team.banned ? 'Unban team' : 'Ban team',
      icon: team.banned ? 'check' : 'closeCircled',
      onClick: toggleBan,
      isDisabled: loading === 'ban'
    },
    {
      text: 'Remove team',
      icon: 'delete',
      onClick: () => setShowRemoveAlert(true),
      isDisabled: loading === 'remove'
    }
  ];

  return (
    <React.Fragment>
      <EntitySettings user={team} options={settings} />
    </React.Fragment>
  );
};

export default Settings;
